// Светлая и тёмная темы интерфейса.
//
// Терминал работает круглосуточно, и ночная смена сидит перед тем же экраном,
// что и дневная. Светлая тема ночью светит в глаза, тёмная днём выцветает под
// прямым светом из окон — поэтому выбор оставлен за оператором, а не выведен
// из времени суток.
//
// Выбор хранится в браузере и применяется до монтирования приложения: иначе
// на каждой загрузке страница успевала бы моргнуть светлым.

const STORAGE_KEY = 'sts-theme'

export const THEMES = ['light', 'dark']

// Пока не выбрали сами — светлая. За настройкой системы шли раньше, но на
// рабочих местах и в браузерах она чаще выставлена тёмной без всякой связи с
// освещением, и терминал открывался тёмным у тех, кто этого не просил.
// Выбранная тема остаётся в браузере и переживает перезагрузку.
export function preferredTheme () {
  const saved = localStorage.getItem(STORAGE_KEY)

  return THEMES.includes(saved) ? saved : 'light'
}

// data-theme на <html>, а не на приложении: всплывающие уведомления и меню
// Vuetify рендерятся в конец body, вне корня приложения, и переменные должны
// доставать и до них.
export function applyTheme (theme, vuetify) {
  const value = THEMES.includes(theme) ? theme : 'light'

  document.documentElement.setAttribute('data-theme', value)
  localStorage.setItem(STORAGE_KEY, value)

  // Vuetify красит свои компоненты сам — без этого поля ввода, меню и диалоги
  // остались бы светлыми внутри тёмной страницы.
  //
  // Из main.js сюда приходит плагин (тема лежит в нём под framework), из
  // компонента — this.$vuetify, который сам этим framework и является.
  // Принимаем оба: иначе второй вызов падал на undefined, тема в data
  // оставалась прежней и переключатель работал ровно один раз.
  const framework = vuetify && (vuetify.framework || vuetify)
  if (framework && framework.theme) framework.theme.dark = value === 'dark'

  return value
}
